import React, { useEffect } from "react";
import styles from "./BOMTwo.module.css";
import logo from "../../../assets/images/coyote-logo.jpg";

const BOMTwo = () => {
  return (
    <div className={styles.bomBody}>
      <div className={styles.bomV6Container}>
        <div className={styles.bomV6Header}>
          <div className={styles.bomV6HeaderContent}>
            <h1>BILL OF MATERIALS (BOM)</h1>
            <p>
              Project: **School District Upgrade (Phase 2)** | Document Date:
              Oct 29, 2025
            </p>
          </div>
          <div className={styles.bomV6LogoPlaceholder}>
            <img src={logo} alt="Coyote Logo" />
          </div>
        </div>

        <div className={styles.bomV6GroupSummary}>
          <p style={{ margin: 0 }}>
            <span className={styles.bomV6ScopeLabel}>SCOPE:</span> Installation
            of Fire Alarm & HVAC Controls Systems.
          </p>
          <p style={{ margin: "5px 0 0" }}>
            <strong>Total Required Products:</strong> 5 |{" "}
            <strong>Total Products to Order:</strong> 2 |{" "}
            <strong>Total Items to Order:</strong> 7 Line Items
          </p>
        </div>

        <div className={styles.bomV6SectionHeader}>
          System: FIRE ALARM (FA-01)
        </div>
        <table className={styles.bomV6DataTable}>
          <thead>
            <tr>
              <th>Phase</th>
              <th>Product (Model)</th>
              <th>Unit of Measure</th>
              <th className={styles.bomV6ReqCol}>Qty Required</th>
              <th className={styles.bomV6AvailCol}>Net Available</th>
              <th className={styles.bomV6OrderCol}>QTY TO ORDER</th>
              <th className={styles.bomV6StatusCol}>Location</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Rough-in</td>
              <td>Fire Alarm Panel (FAP-800)</td>
              <td>unit</td>
              <td className={styles.bomV6ReqCol}>1</td>
              <td className={styles.bomV6AvailCol}>0</td>
              <td className={styles.bomV6OrderCol}>1</td>
              <td
                className={`${styles.bomV6StatusCol} ${styles.bomV6StatusBackorder}`}
              >
                BACKORDER
              </td>
            </tr>
            <tr>
              <td>Rough-in</td>
              <td>Smoke Detector (SD-450)</td>
              <td>unit</td>
              <td className={styles.bomV6ReqCol}>45</td>
              <td className={styles.bomV6AvailCol}>50</td>
              <td className={styles.bomV6OrderCol}>0</td>
              <td
                className={`${styles.bomV6StatusCol} ${styles.bomV6StatusAvailable}`}
              >
                Aisle 3 / R-A
              </td>
            </tr>
            <tr>
              <td>Finishing</td>
              <td>Red Cable 18AWG (FA-18)</td>
              <td>ft</td>
              <td className={styles.bomV6ReqCol}>1000</td>
              <td className={styles.bomV6AvailCol}>1200</td>
              <td className={styles.bomV6OrderCol}>0</td>
              <td
                className={`${styles.bomV6StatusCol} ${styles.bomV6StatusAvailable}`}
              >
                Bulk Cage
              </td>
            </tr>
          </tbody>
        </table>

        <div className={styles.bomV6SectionHeader}>
          System: HVAC CONTROLS (HC-02)
        </div>
        <table className={styles.bomV6DataTable}>
          <thead>
            <tr>
              <th>Phase</th>
              <th>Product (Model)</th>
              <th>Unit of Measure</th>
              <th className={styles.bomV6ReqCol}>Qty Required</th>
              <th className={styles.bomV6AvailCol}>Net Available</th>
              <th className={styles.bomV6OrderCol}>QTY TO ORDER</th>
              <th className={styles.bomV6StatusCol}>Location</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Rough-in</td>
              <td>Thermostat (TH-DIGI)</td>
              <td>unit</td>
              <td className={styles.bomV6ReqCol}>20</td>
              <td className={styles.bomV6AvailCol}>15</td>
              <td className={styles.bomV6OrderCol}>5</td>
              <td
                className={`${styles.bomV6StatusCol} ${styles.bomV6StatusAvailable}`}
              >
                Aisle 4 / R-D
              </td>
            </tr>
            <tr>
              <td>Finishing</td>
              <td>Control Panel (HVA-CP-01)</td>
              <td>unit</td>
              <td className={styles.bomV6ReqCol}>1</td>
              <td className={styles.bomV6AvailCol}>1</td>
              <td className={styles.bomV6OrderCol}>0</td>
              <td
                className={`${styles.bomV6StatusCol} ${styles.bomV6StatusAvailable}`}
              >
                Bin 12
              </td>
            </tr>
          </tbody>
        </table>

        <div className={styles.bomV6Footer}>
          <p>
            BOM Version 6.0 | This document reflects the full project
            requirement for material tracking.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BOMTwo;
